module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "preview-wrapper",
    on: {
      "click": function($event) {
        _vm.close($event)
      },
      "touchmove": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.stopTouch($event)
      }
    }
  }, [_c('div', {
    staticClass: "preview-header"
  }, [_c('i', {
    staticClass: "preview-header-icon icon-back"
  }), _vm._v(" "), _c('div', {
    staticClass: "preview-img-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowLoading),
      expression: "isShowLoading"
    }],
    staticClass: "preview-loading"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowLoading),
      expression: "isShowLoading"
    }]
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.isShowLoading) ? _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowLoading),
      expression: "!isShowLoading"
    }],
    staticClass: "preview-img",
    attrs: {
      "src": _vm.url,
      "alt": _vm.title
    },
    on: {
      "touchstart": function($event) {
        $event.stopPropagation();
        _vm.touchstart($event)
      },
      "touchend": function($event) {
        $event.stopPropagation();
        _vm.touchend($event)
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.imgsList.length),
      expression: "this.imgsList.length"
    }],
    staticClass: "preview-page"
  }, [_vm._v(_vm._s(_vm.page))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46ee275b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/preview/preview_img.vue
// module id = 217
// module chunks = 3